export const InfoIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none" className={className}>
    <path
      d="M15.4993 28.8327C22.8631 28.8327 28.8327 22.8631 28.8327 15.4993C28.8327 8.13555 22.8631 2.16602 15.4993 2.16602C8.13555 2.16602 2.16602 8.13555 2.16602 15.4993C2.16602 22.8631 8.13555 28.8327 15.4993 28.8327Z"
      stroke="#060A3D"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.499 20.8327V15.4993M15.499 10.166H15.5124"
      stroke="#060A3D"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
